<template>
    <div class="form-box">
        <el-form ref="formRef" label-width="85px" :model="form" require-asterisk-position="left" :rules="rules">
            <el-form-item prop="mobile" label="手机号">
                <el-input size="large" v-model.trim="form.mobile" placeholder="请输入手机号" autocomplete="mobile" />
            </el-form-item>
            <el-form-item prop="code" label="验证码" class="captcha">
                <div class="phone-code">
                    <el-input
                        size="large"
                        class="phone-code-input"
                        v-model.trim="form.code"
                        placeholder="请输入验证码"
                        autocomplete="code"
                    />
                    <div class="code-position">
                        <span id="captcha-button" v-if="countDown < 1" class="code-btn" v-loading="wait" @click.stop="send">
                            发送验证码
                        </span>
                        <span v-else class="count-down">{{ countDown }}秒重新获取</span>
                    </div>
                </div>
                <div class="captcha-msg" v-if="showCaptchaMsg">请输入正确的验证码</div>
            </el-form-item>
            <el-form-item prop="password" label="新密码">
                <el-input
                    size="large"
                    v-model.trim="form.password"
                    type="password"
                    show-password
                    placeholder="请输入新密码"
                    autocomplete="new-password"
                />
            </el-form-item>
            <el-form-item prop="confPassword" label="重复密码">
                <el-input
                    size="large"
                    v-model.trim="form.confPassword"
                    type="password"
                    show-password
                    placeholder="请输入"
                    autocomplete="setting-confirm-password"
                />
            </el-form-item>
        </el-form>
        <div class="btn-box">
            <el-button @click="emits('cancel')" class="cancel-btn">取消</el-button>
            <el-button :color="theme.themeColor" @click="settingPassword" :loading="btnLoading" :disabled="isSubmitDisabled"
                >确认</el-button
            >
        </div>
    </div>
</template>

<script setup lang="ts">
import { ElFormItem, ElForm } from "element-plus";
import { theme } from "@/config/sassTheme";
import { computed, ref } from "vue";
import { ElMessage, ElButton, ElInput, FormInstance } from "element-plus";
import { customerMessageService } from "@/api/services/customerMessageService.ts";
import { customerService } from "@/api/services/sassCustomerService.ts";
const emits = defineEmits(["cancel", "isSelectAgreements"]);
const props = defineProps<{
    isChecked: boolean;
}>();
const formRef = ref<FormInstance>();
const form = ref({
    mobile: "",
    code: "",
    password: "",
    confPassword: ""
});
const btnLoading = ref<boolean>(false);
const isSubmitDisabled = computed(() => {
    return !(form.value.mobile && form.value.code && form.value.password && form.value.confPassword);
});
// 校验是否是手机号
const phoneRuleCallback = (_: unknown, value: string, callback: (error?: Error) => void) => {
    const reg = /^1[3456789]\d{9}$/;
    if (reg.test(value)) {
        callback();
    } else {
        callback(new Error("请输入正确的手机号"));
    }
};
// 验证密码
const passwordRuleCallback = (_: unknown, value: string, callback: (error?: Error) => void) => {
    // 正则表达式验证密码为6-16位包含字母和数字
    const passwordRegex = /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{6,16}$/;
    if (passwordRegex.test(value)) {
        callback();
    } else {
        callback(new Error("密码限制6-16位包含字母、数字的密码"));
    }
};
// 验证 两次密码输入是否一致
const repeatPasswordRuleCallback = (_: unknown, value: string, callback: (error?: Error) => void) => {
    if (value === form.value.password) {
        callback();
    } else {
        callback(new Error("两次密码输入不一致"));
    }
};

// 验证规则
const rules = ref({
    mobile: [
        { required: true, message: "请输入手机号", trigger: "blur" },
        { validator: phoneRuleCallback, trigger: "blur" }
    ],
    code: [{ required: true, message: "请输入验证码", trigger: "blur" }],
    password: [
        { required: true, message: "请设置6-16位包含字母、数字的密码", trigger: "blur" },
        { validator: passwordRuleCallback, trigger: "blur" }
    ],
    confPassword: [
        { required: true, message: "请再次输入", trigger: "blur" },
        { validator: repeatPasswordRuleCallback, trigger: "blur" }
    ]
});

const showCaptchaMsg = ref(false);

// 等待倒计时
const wait = ref<boolean>(false);
// 倒计时
const countDown = ref(0);

// 计时
const setCodeCountDown = () => {
    const timer = setInterval(() => {
        if (countDown.value > 0 && countDown.value <= 60) {
            countDown.value--;
        } else {
            clearInterval(timer);
        }
    }, 1000);
};

// 发送验证码
const send = async () => {
    wait.value = true;
    try {
        await formRef.value!.validateField("mobile");
        await customerMessageService.sendCaptcha(form.value.mobile);
        countDown.value = 60;
        wait.value = false;
        setCodeCountDown();
    } catch (e) {
        console.error(e);
        wait.value = false;
    }
};

// 重置密码
const settingPassword = () => {
    formRef.value!.validate(async valid => {
        if (valid) {
            //是否勾选协议
            if (!props.isChecked) {
                emits("isSelectAgreements");
                return;
            }
            try {
                btnLoading.value = true;
                await customerService.forgotPassword(form.value);
                btnLoading.value = false;
                emits("cancel");
                ElMessage.success("新密码设置成功");
            } catch (error) {
                btnLoading.value = false;
                console.log(error);
            }
        }
    });
};
</script>

<style scoped lang="scss">
@import "./index.scss";
</style>
